import { Entity } from '../../../../base/Entity'

export type OrganizationPrimaryKeyType = number
export const organizationPrimaryKeyAttributeName: 'id' = 'id'
export interface OrganizationAttributesType {
  id: number
  name?: string
}

export class Organization<
  AttributesType extends OrganizationAttributesType = OrganizationAttributesType
> extends Entity<OrganizationPrimaryKeyType, AttributesType> {
  static readonly modelName: string = 'Organization'
  static readonly entityName: string = 'Organization'
  static readonly primaryKeyAttributeName: 'id' = 'id'

  get id (): OrganizationPrimaryKeyType {
    return this.primaryKey
  }

  get associationPropertyPaths (): string[][] { return [] }
  readonly hasAssociations: false = false

  get name (): AttributesType['name'] {
    return this.readAttribute('name')
  }
}
